<app-titulo texto="Pesquisa de Satisfação"></app-titulo>
<div class="w-full text-center text-md font-opensans text-700 mt-8">
  <p class="font-opensans">Obrigado por participar da nossa Pesquisa!</p>
  <h4 class="text-900">
    Não esqueça de anotar o Número do Atendimento: {{ id?.codigoFormatado }}
  </h4>
  <p>
    e acompanhar sua solicitação através de nosso
    <a href="/servico/acompanhar" target="_blank">site</a>.
  </p>
  <p>
    Caso tenha dúvidas, entre em contato através de nossa Central de
    Atendimento<br />
    disponível 24 horas pelo número <b class="text-900">115</b> e
    <b class="text-900">0800 643 0195</b>
  </p>
</div>
